function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: 181.628,
  height: 31.9767,
  rx: 10,
  fill: "url(#paint0_linear_1_182)"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  y: 38.3721,
  width: 220,
  height: 28.7791,
  rx: 10,
  fill: "url(#paint1_linear_1_182)"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  y: 111.919,
  width: 220,
  height: 28.7791,
  rx: 10,
  fill: "url(#paint2_linear_1_182)"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 38.3721,
  y: 73.5465,
  width: 181.628,
  height: 31.9767,
  rx: 10,
  fill: "url(#paint3_linear_1_182)"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("ellipse", {
  cx: 15.9884,
  cy: 89.5349,
  rx: 15.9884,
  ry: 15.9884,
  fill: "url(#paint4_linear_1_182)"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("ellipse", {
  cx: 204.012,
  cy: 15.9884,
  rx: 15.9884,
  ry: 15.9884,
  fill: "url(#paint5_linear_1_182)"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_1_182)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.1093 90.9056H135.202V60.3393H84.1093V90.9056ZM94.3278 55.245H124.983V43.7826C124.983 36.0703 118.668 29.7731 110.933 29.7731H108.378C100.643 29.7731 94.3278 36.0703 94.3278 43.7826V55.245ZM140.311 55.245V96H79V55.245H89.2186V43.7826C89.2186 33.2401 97.805 24.6787 108.378 24.6787H110.933C121.506 24.6787 130.093 33.2401 130.093 43.7826V55.245H140.311Z",
  fill: "#FF5E31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.1093 90.9056H135.202V60.3393H84.1093V90.9056ZM94.3278 55.245H124.983V43.7826C124.983 36.0703 118.668 29.7731 110.933 29.7731H108.378C100.643 29.7731 94.3278 36.0703 94.3278 43.7826V55.245ZM140.311 55.245V96H79V55.245H89.2186V43.7826C89.2186 33.2401 97.805 24.6787 108.378 24.6787H110.933C121.506 24.6787 130.093 33.2401 130.093 43.7826V55.245H140.311Z",
  stroke: "#FF5E31",
  strokeWidth: 2
}));

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 83,
  y: 59,
  width: 54,
  height: 33,
  fill: "#FF5E31"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M115.77 82.7263L115.902 83.8281L112.998 85.5977L112.767 83.3607C113.075 83.2716 113.394 83.1826 113.724 83.0936L113.823 83.9283L115.308 83.0268L115.77 82.7263ZM98.478 80.1554C98.236 80.5338 97.983 80.9011 97.719 81.2572H97.653L94.485 81.5911L94.188 78.8867L95.277 78.3858L95.904 77.2506L97.917 77.7181C97.939 78.0965 98.005 78.4637 98.115 78.8199L96.399 78.3858L96.003 79.1871L95.244 79.521L95.376 80.5227L98.478 80.1554ZM125.208 70.8735L125.637 70.9069L126 74.613L125.769 74.7799C125.131 75.2028 124.372 75.8817 123.492 76.8166C122.524 77.8405 121.666 78.575 120.918 79.0202C120.654 79.176 120.401 79.2984 120.159 79.3875L120.522 80.0552L121.05 81.1571C121.292 81.6022 121.353 82.0752 121.232 82.5761C121.111 83.0769 120.83 83.4608 120.39 83.728L118.674 84.7964L116.958 85.8314L116.595 82.2589L117.222 81.8582L116.265 81.2906C113.977 82.27 111.799 82.871 109.731 83.0936C107.861 83.3162 106.101 83.2271 104.451 82.8265C104.099 83.0268 103.736 83.1937 103.362 83.3273C102.746 83.5721 102.097 83.728 101.415 83.7947C101.195 83.8392 101.008 83.8615 100.854 83.8615L99.798 87L97.158 85.6645L97.587 84.4625L97.125 83.127L97.356 82.8932C98.126 82.1364 98.852 81.1793 99.534 80.0219C98.874 78.9089 98.599 77.7403 98.709 76.5161H98.94C99.226 76.4716 99.49 76.3937 99.732 76.2824C99.534 77.4843 99.798 78.6418 100.524 79.7547L100.689 79.9885L100.557 80.2556C100.007 81.324 99.237 82.3702 98.247 83.3941L98.61 84.4625L98.379 85.1636L99.237 85.5977L100.128 82.8599L100.491 82.8932C101.305 82.8932 102.086 82.7597 102.834 82.4926C104.44 81.9361 105.485 80.9233 105.969 79.4543L106.035 79.2539L106.134 78.9534L107.091 79.2873L106.926 79.7547C106.728 80.289 106.464 80.7898 106.134 81.2572C105.936 81.5466 105.727 81.8026 105.507 82.0251C108.389 82.5371 111.623 82.0808 115.209 80.6562H115.176L115.077 79.7881L114.879 77.8516L115.308 77.8182L115.869 77.7515L116.1 80.0552L119.136 81.8582L117.618 82.7597L117.783 84.162L119.895 82.8932C120.093 82.7597 120.225 82.5705 120.291 82.3256C120.357 82.0808 120.324 81.8471 120.192 81.6245L118.806 78.8533L119.565 78.5528C120.049 78.3747 120.495 78.141 120.902 77.8516C121.309 77.5623 121.627 77.3063 121.858 77.0837C122.089 76.8611 122.403 76.5383 122.799 76.1154C123.635 75.2028 124.361 74.535 124.977 74.1121L124.746 71.8417C124.262 71.8195 123.811 71.7861 123.393 71.7416C122.909 71.6748 122.183 71.2741 121.215 70.5396C120.687 70.1389 120.258 69.8384 119.928 69.6381L120.093 71.2407L119.136 71.3409L119.07 70.7733L118.641 66.9337C117.959 67.134 117.431 67.5847 117.057 68.2859C116.683 68.987 116.507 69.7271 116.529 70.5062V70.573L116.562 70.7733L115.572 70.8735L115.539 70.5396C115.539 70.1834 115.572 69.7939 115.638 69.371C114.978 69.5491 114.296 69.7717 113.592 70.0388L115.143 73.0771L114.285 73.5445L113.856 72.7098L112.833 70.7065L111.744 68.6365L111.513 68.169L110.523 66.2325C110.281 65.8096 109.94 65.4868 109.5 65.2642C109.06 65.0417 108.598 64.9637 108.114 65.0305L94.155 66.5998C94.309 67.0672 94.595 67.4345 95.013 67.7016C95.431 67.9687 95.893 68.08 96.399 68.0355L97.95 67.8685L100.557 67.568L109.005 66.5998L109.5 67.5346L104.385 68.1356C104.473 68.425 104.638 68.6921 104.88 68.937C105.364 69.4266 105.947 69.6381 106.629 69.5713L108.312 69.371L110.325 69.1373L110.82 70.1055L108.411 70.3726L107.652 70.4394C107.74 70.751 107.894 71.0182 108.114 71.2407H108.147C108.631 71.7527 109.214 71.9642 109.896 71.8751H110.061L111.645 71.7082L112.107 72.643L110.16 72.8434L110.028 72.8768L105.21 73.411C104.44 73.5 103.736 73.3219 103.098 72.8768C102.46 72.4316 102.042 71.8306 101.844 71.0738C101.14 71.0515 100.518 70.829 99.9795 70.406C99.4405 69.9831 99.083 69.4266 98.907 68.7366L98.082 68.8368L96.531 69.0371C95.651 69.1262 94.8755 68.898 94.2045 68.3527C93.5335 67.8073 93.154 67.1006 93.066 66.2325L93 65.7317L108.015 64.0289C108.697 63.9398 109.346 64.0567 109.962 64.3795C110.578 64.7022 111.051 65.1641 111.381 65.7651L113.13 69.1373H113.196C114.12 68.7589 115.044 68.4695 115.968 68.2692C116.254 67.6014 116.667 67.0449 117.206 66.5998C117.745 66.1546 118.344 65.8986 119.004 65.8318L119.499 65.7651L119.796 68.4361C120.28 68.6587 120.951 69.0928 121.809 69.7383C122.645 70.3615 123.228 70.6954 123.558 70.7399C124.152 70.829 124.702 70.8735 125.208 70.8735ZM106.992 71.3743C106.838 71.1072 106.728 70.8401 106.662 70.573L102.834 71.007C102.944 71.3186 103.115 71.5858 103.346 71.8083C103.577 72.0309 103.846 72.1979 104.154 72.3092C104.462 72.4205 104.781 72.465 105.111 72.4427L107.652 72.1422C107.388 71.9196 107.168 71.6637 106.992 71.3743ZM103.725 69.0705C103.571 68.8034 103.461 68.5252 103.395 68.2358L100.755 68.5363L99.897 68.6365C100.051 69.1039 100.343 69.4767 100.772 69.755C101.201 70.0332 101.657 70.1389 102.141 70.0722L104.385 69.8384C104.121 69.6158 103.901 69.3599 103.725 69.0705ZM99.996 73.2106C100.282 72.7432 100.656 72.3092 101.118 71.9085L101.151 71.8751L101.184 71.8417H101.217C101.349 72.1311 101.514 72.4205 101.712 72.7098C101.558 72.8434 101.41 72.9936 101.267 73.1606C101.124 73.3275 101.019 73.4555 100.953 73.5445C100.887 73.6336 100.854 73.6892 100.854 73.7115L100.194 74.9134C99.864 75.3586 99.413 75.6146 98.841 75.6814C98.335 75.7482 97.873 75.6257 97.455 75.3141C97.037 74.9802 96.7895 74.5462 96.7125 74.012C96.6355 73.4778 96.762 72.9881 97.092 72.5429L97.389 72.1422L98.082 72.7098L98.181 72.7432L97.884 73.1439C97.73 73.3665 97.6695 73.6113 97.7025 73.8784C97.7355 74.1455 97.8565 74.357 98.0655 74.5128C98.2745 74.6686 98.5055 74.7298 98.7585 74.6964C99.0115 74.663 99.215 74.5462 99.369 74.3458L99.996 73.2106Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1_182",
  x: 58,
  y: 3.67867,
  width: 103.311,
  height: 113.321,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.192157 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_182"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_182",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1_182",
  x1: 0.506171,
  y1: 28.8442,
  x2: 47.5546,
  y2: -69.9821,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1_182",
  x1: 0.613109,
  y1: 64.3319,
  x2: 34.9141,
  y2: -32.637,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1_182",
  x1: 0.613109,
  y1: 137.878,
  x2: 34.9141,
  y2: 40.9095,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1_182",
  x1: 38.8783,
  y1: 102.391,
  x2: 85.9267,
  y2: 3.5644,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1_182",
  x1: 0.0891146,
  y1: 102.391,
  x2: 39.5259,
  y2: 87.8066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1_182",
  x1: 188.112,
  y1: 28.8442,
  x2: 227.549,
  y2: 14.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#F2F2F2",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869792,
  stopColor: "#EDEDED"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 141,
    viewBox: "0 0 220 141",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/basic-plan-icon.17c05f5b.svg";
export { SvgComponent as ReactComponent };